import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { MenuItemComponentType } from "../../../../../constants";
import { MenuActionCreators } from "../../../../../redux/action-creators";
import { MenuSelectors } from "../../../../../redux/selectors";
import { useSpectateCategoryItemsWithFavorites } from "./useSpectateCategoryItemsWithFavorites";
import { TrackingInfo } from "../../../../tracking/TrackingInfoMenu";

export const useSpectateMenuItemsPC = () => {
  const { hiddenCategories, visibleCategories } =
    useSpectateCategoryItemsWithFavorites();

  const menuItems = useSelector(MenuSelectors.menuItems);
  const dispatch = useDispatch();
  useEffect(() => {
    const quickLinkItems = getPCSpectateMenuItems(
      visibleCategories,
      hiddenCategories
    );

    if (quickLinkItems && quickLinkItems.length) {
      dispatch(MenuActionCreators.setMenuItems(quickLinkItems));
    }
  }, [dispatch, visibleCategories, hiddenCategories]);

  return menuItems;
};

export const getPCSpectateMenuItems = (menuCategories, hiddenCategories) => {
  if (!menuCategories || !menuCategories.length > 0) return null;

  const categories = menuCategories.slice();
  if (hiddenCategories.length) {
    categories.push(hiddenCategories[hiddenCategories.length - 1]);
  }

  const menuItems = categories?.map((menuItem, idx) => {
    const item = menuItem;
    const hasChildren = menuItem.items?.length > 0;
    const isLastItem = idx === categories.length - 1;

    const menuItemProps = {
      item,
      dataTestId: isLastItem ? "all-sports" : menuItem.termKey,
      trackingInfo: TrackingInfo
    };

    const componentType = hasChildren
      ? MenuItemComponentType.ExpandableSportCategoryMenuItem
      : MenuItemComponentType.SportCategoryMenuItem;

    return {
      key: `menu-item-${item.fullURL}-${item.ID || item.sportID}`,
      props: menuItemProps,
      componentType
    };
  });

  return menuItems;
};
